import {JumpToModule} from './../../../widgets/jump-to/jump-to.module';
import {InfoHeaderModule} from 'src/app/widgets/info-header/info-header.module';
import {TaskPopupModule} from './../../task/task-popup/task-popup.module';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DeepDiveRoutingModule} from './deep-dive-routing.module';
import {DxDataGridModule, DxChartModule, DxTextAreaModule, DxPopupModule, DxButtonModule, DxDropDownButtonModule, DxRangeSelectorModule, DxSwitchModule} from 'devextreme-angular';
import {DevEpressCommonModule} from 'src/app/dev-epress-common.module';
import {StockService} from '../stock.service';
import {DeepDiveComponent} from './deep-dive.component';
import {TaskListPopupModule} from '../../task/task-list-popup/task-list-popup.module';
import {BookmarkModule} from 'src/app/widgets/bookmark/bookmark.module';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';


@NgModule({
	declarations: [DeepDiveComponent],
	imports: [
		CommonModule,

		DxTableControllerDirective,

		JumpToModule,

		DeepDiveRoutingModule,
		DxDataGridModule,
		DxChartModule,
		DevEpressCommonModule,
		DxTextAreaModule,
		DxButtonModule,
		DxPopupModule,
		DxDropDownButtonModule, DxRangeSelectorModule,
		TaskPopupModule,
		TaskListPopupModule,
		InfoHeaderModule, DxSwitchModule, BookmarkModule
	],
	providers: [StockService]
})
export class DeepDiveModule {}
